import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=cdf71be2&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=cdf71be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf71be2",
  null
  
)

export default component.exports